import React from 'react';
import { twMerge } from 'tailwind-merge';
import { useRingStyle } from './util';
export var Radio = function (_a) {
    var option = _a.option, isSelected = _a.isSelected, onChange = _a.onChange, isDisabled = _a.isDisabled, name = _a.name, inputClassName = _a.inputClassName;
    var ringStyle = useRingStyle();
    return (React.createElement("input", { type: "radio", style: ringStyle, value: option.value, checked: isSelected, disabled: isDisabled, onChange: function () { return onChange(option); }, name: name, className: twMerge('form-radio h-4 w-4 cursor-pointer border border-solid border-gray-300 text-primary disabled:cursor-not-allowed disabled:bg-gray-100 disabled:hover:bg-gray-100', inputClassName) }));
};
